import config from '../data/config.json';
import dict from '../data/dictionary.json';
//import provsor from '../data/provincias-espanolas_original.json';
//import provsor from '../data/provs_pro.json';
import munobj from '../data/munis_simp10.json';
import txobj from '../data/taxons.json';
//import wdquery from '../data/wdquery.json';

import { parse, stringify } from 'wkt';
import { booleanPointInPolygon } from '@turf/turf';
import { saveAs } from 'file-saver';

import { Sesion, Datos, Crafts } from '../main.js';
import { pintarParcelas } from './plots.js';
import { getAllSubclasses, getLiteral } from './util.js';
import { getGrid, getCeldaBounds, getCeldaGridMatrix } from './grid.js';
import { setEventData, sendTimedEvent } from './events.js';


const MAX_HILOS = 4; // número máximo de peticiones a la red

/////////
// UTILES
function descomponerCraftsResources(id, uris) {
	// array a devolver con la descomposición
	let devolver = [];
	// array de huérfanos (para combinar)
	let huerfanos = [];

	// organizo las uris por sus namespaces
	let nsuris = {};
	// analizo cada uri y la meto por su namespace
	for (let uri of uris) {
		// si no es un string me salgo
		if (typeof uri != "string")
			continue;	
		// obtengo namespace
		const indfin = Math.max( uri.lastIndexOf('/'), uri.lastIndexOf('#') );
		const ns = uri.substring(0, indfin + 1);
		// guardo
		if (nsuris[ns] == undefined)
			nsuris[ns] = [];
		nsuris[ns].push(uri);
	}
	
	// analizo cada namespace encontrado
	const nss = Object.keys(nsuris);
	for (let i=0; i<nss.length; i++) {
		// obtengo el namespace y sus uris
		const mins = nss[i];
		const misuris = nsuris[mins];
		// preparo lotes de 200
		const lote = 200;
		for (let ind=0; misuris.length > ind*lote; ind++) {
			const begin = ind*lote;
			const end = misuris.length > (ind + 1)*lote? (ind + 1)*lote : misuris.length;
			// si este lote es inferior a 10, los meto en huérfanos
			if (end - begin < 10) 
				huerfanos = huerfanos.concat( misuris.slice( begin, end ) );
			else {
				// creo un objeto para este lote
				let obj = {};
				obj.id = id;
				obj.ns = mins;
				obj.nspref = 'p'; // arbitrario
				obj.iris = [];
				// meto cada iri con prefijo en el lote
				for (let j=begin; j<end; j++) {
					const uri = misuris[j];
					const prefuri = 'p:' + uri.substring(mins.length);
					obj.iris.push(prefuri);				
				}
				// y guardo el objeto en devolver
				devolver.push(obj);
			}
		}
	}
	
	// proceso los huérfanos en lotes de 40
	const lote = 40;
	for (let ind=0; huerfanos.length > ind*lote; ind++) {
		const begin = ind*lote;
		const end = huerfanos.length > (ind + 1)*lote? (ind + 1)*lote : huerfanos.length;
		// creo un objeto para este lote
		let obj = {};
		obj.id = id;
		obj.iris = huerfanos.slice( begin, end );
		// y guardo el objeto en devolver
		devolver.push(obj);
	}
		
	// devuelvo la descomposición
	return devolver;
}
// extraigo un objeto con el mapeo de urls cacheadas a iris de un id determinado
function getCachedObjectMapping(id, iris) {
	// inicializo las cosas a retornar
	const objcache = {}; // el objeto de resultados: url cacheada a array de iris
	const pendingiris = [];  // las iris no cacheadas
	for (const iri of iris) {
		const curl = Crafts.getCacheUrl(id, iri);
		if (!curl) // no se encontró
			pendingiris.push(iri); 
		else { // la guardo con la url de la caché
			if (!objcache[curl])
				objcache[curl] = [];
			objcache[curl].push(iri);
		}
	}
	return [objcache, pendingiris];
}
// util para usos y taxones
function initClass(objbase, cluri) {
	if (!objbase[cluri]) {
		objbase[cluri] = {
			"uri": cluri, 
			"subclasses": [], 
			"superclasses": []
		};
	}
}
// bounding box de un geojson (para municipios)
function getBoundingBox(geojson) {	
	let parescoords = null;
	if (geojson.type === "Polygon")
		parescoords = geojson.coordinates.flat(1);
	else if (geojson.type === "MultiPolygon")
		parescoords = geojson.coordinates.flat(2);
	
	let south = Infinity, north = -Infinity;
	let west = Infinity, east = -Infinity;
	
	parescoords.forEach(([lng, lat]) => {
		if (lng < west) west = lng;
		if (lng > east) east = lng;
		if (lat < south) south = lat;
		if (lat > north) north = lat;
	});
	return { west, south, east, north };
}


//////////////////////////////////////
// INICIALIZACIONES PROVEEDOR DE DATOS
// info de todos los taxones
async function getTaxonsInfo() {
	// miro si están los taxones en la caché
	const txurl = config.craftsConfig.api + "/object?id=mistaxones";
	await Crafts.getCacheData(txurl).then(data => {
		// guardo 
		Datos.taxones = data;
    })
    .catch(async error => {
  		console.debug("No están los taxones en la caché...");  		
  		
  		// 13/5/2026 debido al problema con Wikidata, leo directamente del fichero
		//console.time("Carga taxones de fichero");
		Datos.taxones = txobj;
		// guardo en la caché
		Crafts.cacheandoAdhoc(txurl, Datos.taxones);
		//console.timeEnd("Carga taxones de fichero");
		
  		/*
  		// procesamiento anterior para extraer los datos de los endpoints
  		// obtengo info de subclases de los taxones a partir de plantae
		// preparo objeto para la petición a CRAFTS de pares de superclase-subclase a partir de config.txPlantae
		const qobj = { 'ancestor': config.txPlantae };
		const datos = await Crafts.getData(config.craftsConfig.querySubclasses, qobj, true); // (NO CACHEABLE)
		// fue todo bien, inicializo clase de plantae
		initClass(Datos.taxones, config.txPlantae);
		// analizo cada fila de los resultados
		for (let row of datos.results.bindings) {
			// obtengo datos
			const supuri = row.sup.value;
			const suburi = row.sub.value;
			// inicializo clases
			initClass(Datos.taxones, supuri);
			initClass(Datos.taxones, suburi);
			// guardo subclase
			Datos.taxones[supuri].subclasses.push(suburi);
			// guardo superclase
			Datos.taxones[suburi].superclasses.push(supuri);
		}
		// obtengo taxones expandidos
		let evsuris = Object.keys(Datos.taxones);
		while(evsuris.length > 0) {
			let newevsuris = [];
			for (let suri of evsuris) {
				// recupero taxon
				const taxon = Datos.taxones[suri];
				// obtengo la uri de cualquier subespecie sin expandir
				const algsubsuri = taxon.subclasses.find(subsuri => Datos.taxones[subsuri].expuris === undefined);
				// si no está definida, puedo hacer la expansión de uris
				if (algsubsuri == undefined) {
					// inicializo con la uri de la propia taxon
					taxon.expuris = [suri];
					// y ahora incluimos las de la subclases
					for (let subsuri of taxon.subclasses)
						taxon.expuris = [...new Set([...taxon.expuris, ...Datos.taxones[subsuri].expuris])];
				}
				else // hay que esperar a la siguiente iteración
					newevsuris.push(suri);
			}
			// actualizo lista de tipos a evaluar
			evsuris = newevsuris;
		}
		// obtengo taxones expandidos superiores
		evsuris = Object.keys(Datos.taxones);
		while(evsuris.length > 0) {
			let newevsuris = [];
			for (let suri of evsuris) {
				// recupero taxon
				const taxon = Datos.taxones[suri];
				// obtengo la uri de cualquier supertaxon sin expandir
				const algsupersuri = taxon.superclasses.find(supersuri => Datos.taxones[supersuri].superexpuris === undefined);
				// si no está definida, puedo hacer la expansión de uris
				if (algsupersuri == undefined) {
					// inicializo con la uri de la propia taxon
					taxon.superexpuris = [suri];
					// y ahora incluimos las de la superclases
					for (let supersuri of taxon.superclasses)
						taxon.superexpuris = [...new Set([...taxon.superexpuris, ...Datos.taxones[supersuri].superexpuris])];
				}
				else // hay que esperar a la siguiente iteración
					newevsuris.push(suri);
			}			
			// actualizo lista de tipos a evaluar
			evsuris = newevsuris;
		}
	
		// obtengo el número de parcelas de cada especie por versión de inventario
		const suris = Object.keys(Datos.taxones); 
		// inicializo a 0 el número de parcelas por cada versión de inventario
		for (let suri of suris) {
			Datos.taxones[ suri ].nplots = {};
			for (let ifn of config.ifnVersions) 
				Datos.taxones[suri].nplots[ifn] = { 'count': 0 };		
		}
	
		// extraigo el número de parcelas de cada taxón con queryCountPlotsPerAllTaxons (para los diferentes ifn)
		for (let ifn of config.ifnVersions) {
			// preparo objeto para la petición a CRAFTS con la versión del ifn
			const qobj = { [ifn]: true };
			const datos = await Crafts.getData(config.craftsConfig.queryCountPlotsPerAllTaxons, qobj, true); // (NO CACHEABLE)	
			// analizo fila a fila
			for (let row of datos.results.bindings) {
				// obtengo datos
				const cluri = row.tx.value;
				const count = Number(row.nplots.value);
				// guardo sólo si existe
				if (Datos.taxones[cluri] && Datos.taxones[cluri].nplots[ifn])
					Datos.taxones[cluri].nplots[ifn].count = count;
			}			
		}		
	
		// ahora obtengo la información de cada taxón
		// para los taxones pendientes hago la llamada a CRAFTS
		// pero no hago las peticiones en paralelo para no inundar a Wikidata
	
		// pido descomponer en objetos para la llamada resources de CRAFTS	
		const objrs = descomponerCraftsResources('Species', suris);
		// ya tengo los objetos a pedir, lanzo las peticiones en secuencia a CRAFTS
		for (const objr of objrs) {
			// hago la llamada a CRAFTS	y espero resultados (NO CACHEABLE)	
			let datos = await Crafts.getData(config.craftsConfig.resourcesTemplate, objr, true);
			// convierto en array si es necesario
			if (!Array.isArray(datos))
				datos = [ datos ];
			// actualizo taxon a taxon
			for (let dato of datos)
				Object.assign(Datos.taxones[dato.iri], dato);
		}
		
		
  		// 13/5/2026 	NUEVA EXTRACCIÓN DEBIDO A LOS PROBLEMAS CON WIKIDATA
  		
		// extracción de las IRIs de Wikidata, ahora trabajaremos con ellas
		//const wds = [...new Set(
		//	Object.values(Datos.taxones).map(item => item.wikidata)
		//)];
		//const blobwds =  new Blob([JSON.stringify(wds, null, 2)], {type: "text/plain;charset=utf-8"});
		//saveAs(blobwds, "wds.json");
		
		// preparo un objeto con las entidades de Wikidata
		const wikients = {};
		// inicialización de opciones
		const options = {
			method: 'GET',
			headers: { 'Content-Type': 'application/json' }
		};
		// trabajo con la consulta
		// tarda bastante porque las peticiones se hacen en secuencia 
		// (no importa porque sólo lo haremos una vez para preparar el fichero)
		for (const binding of wdquery.results.bindings) {
			//console.log(binding.tx.value);			
			const tx = binding.tx.value;
			const txobj = {
				wikipedia : { "en" : binding.wikipediaEN.value },
				images : []
			};
			if (binding.wikipediaES)
				txobj.wikipedia.es = binding.wikipediaES.value;
			if (binding.wikispecies)
				txobj.wikispecies = binding.wikispecies.value;
			if (binding.gbif)
				txobj.gbif = binding.gbif.value;
			// aquí extraigo los datos de la API de wikimedia
			// inglés
			const titen = txobj.wikipedia.en.slice(txobj.wikipedia.en.lastIndexOf("/") + 1);
			const respen = await fetch("https://en.wikipedia.org/api/rest_v1/page/summary/" + titen, options);
			if (respen.ok) {
				const datos = await respen.json();
				if (datos.thumbnail)
					txobj.images.push(datos.thumbnail.source);
				if (datos.extract)
					txobj.extract = { "en" : datos.extract };
			}
			// español
			if (txobj.wikipedia.es) {		
				const tites = txobj.wikipedia.es.slice(txobj.wikipedia.es.lastIndexOf("/") + 1);
				const respes = await fetch("https://es.wikipedia.org/api/rest_v1/page/summary/" + tites, options);
				if (respes.ok) {
					const datos = await respes.json();
					if (datos.thumbnail) {
						// guardo la imagen si no está repetida
						if (txobj.images.length == 0 || txobj.images[0] !== datos.thumbnail.source)
							txobj.images.push(datos.thumbnail.source);
					}
					if (datos.extract) {
						if (!txobj.extract)
							txobj.extract = {};		
						txobj.extract.es = datos.extract;
					}
				}
			}	
			// guardo
			wikients[tx] = txobj;
		}
		//console.log(wikients);
			
		// consolido los resultados
		for (const tx in Datos.taxones) {
			const wdiri = Datos.taxones[tx].wikidata;		
			if (wdiri !== undefined && wikients[wdiri] !== undefined)
				Object.assign(Datos.taxones[tx], wikients[wdiri]);
		}
		
		// guardo los taxones
		const blobtx =  new Blob([JSON.stringify(Datos.taxones, null, 2)], {type: "text/plain;charset=utf-8"});
		saveAs(blobtx, "taxons.json");
		
		// guardo en la caché
		//Crafts.cacheandoAdhoc(txurl, Datos.taxones);
		*/			
    });
}

// obtengo los datos de provincias
async function getProvincesInfo() {
	// apañete
	/*for (const feat of provsor.features)
		feat.geometry = null;
	const blobprov =  new Blob([JSON.stringify(provsor, null, 2)], {type: "text/plain;charset=utf-8"});
	saveAs(blobprov, "provs_nogeo.json");*/
	/*for (const feat of provsnuts.features) {
		const code = feat.properties.CODNUT3;
		const blobgeo =  new Blob([JSON.stringify(feat.geometry, null)], {type: "text/plain;charset=utf-8"});
		saveAs(blobgeo, "geo_"+code+".json");
	}*/
	/*
	const feat = provsnuts.features.find(pr => pr.properties.CODNUT3 === "ES416");
	const blobgeo =  new Blob([JSON.stringify(feat.geometry, null)], {type: "text/plain;charset=utf-8"});
	saveAs(blobgeo, "geo_aux.json");*/

	// miro si están las provincias en la caché
	const provurl = config.craftsConfig.api + "/object?id=misprovs";
	await Crafts.getCacheData(provurl).then(data => {
		// guardo 
		Datos.provs = data;		
    })
    .catch(async error => {
  		console.debug("No están las provincias en la caché...");
  		
  		// obtengo las provincias base de España del triplestore
		let prbase = [];
		const datos = await Crafts.getData(config.craftsConfig.queryNopars, 
			{ queryName: "baseProvinces" }, true); // no la cacheo
		for (let row of datos.results.bindings) {
			// obtengo datos
			let prov = { iri: row.prov.value };
			// guardo cada resultado
			Datos.provs[prov.iri] = prov;
			prbase.push(prov.iri);
		}
  		
		// inicializo las promesas
		let promesas = [];
  		// pido descomponer en objetos para la llamada resources de CRAFTS	
		const objrs = descomponerCraftsResources('BaseProvince', prbase);			
		// ya tengo los objetos a pedir, lanzo las peticiones en paralelo a CRAFTS		
		for (let objr of objrs) {
			// creo una promesa para cada petición (todo paralelo)
			promesas.push( new Promise(async function(resolve, reject) {
				try {
					// hago la llamada a CRAFTS	y espero resultados (NO CACHEABLE)
					let datos = await Crafts.getData(config.craftsConfig.resourcesTemplate, objr, true);
					// convierto en array si es necesario
					if (!Array.isArray(datos))
						datos = [ datos ];
					// actualizo provincia a provincia
					for (let dato of datos) {
						Object.assign(Datos.provs[dato.iri], dato);
						// reajuste geometría
						if (Datos.provs[dato.iri].wkt) {
							Datos.provs[dato.iri].geometry = parse(Datos.provs[dato.iri].wkt); // transformo a GeoJSON
							delete Datos.provs[dato.iri].wkt;
						}
					}
					// resuelvo la promesa
					resolve(true);
				} catch(err) {
					reject(err);
				}
			}) );
		}
		
		// espero a que terminen todas las promesas
		await Promise.all(promesas);
		
		// TODO: apañete para utilizar las geometrías originales de las provincias
		/*for (const priri in Datos.provs) {
			const ac = getLiteral(Datos.provs[priri].adminCode);
			const pror = provsor.features.find(pror => pror.properties.admin2_code === ac);
			if (!pror)
				console.error(priri + " " + ac);
			else
				Datos.provs[priri].geometry = pror.geometry;
		}*/
	
		// guardo en la caché		
		Crafts.cacheandoAdhoc(provurl, Datos.provs);
  	});
}


// obtengo los datos de municipios
async function getMunicipalitiesInfo() {
	// miro si están los municipios en la caché
	const munurl = config.craftsConfig.api + "/object?id=mismunis";
	await Crafts.getCacheData(munurl).then(data => {
		// guardo 
		Datos.munis = data;		
    })
    .catch(async error => {
  		console.debug("No están los municipios en la caché...");
  		
		// proceso fichero GeoJSON simplificado al 10% (va bien, cargarlos del triplestore cuando estén)
		console.time("Proceso municipios simplificados al 10%");
		Datos.munis = {};
		for (const feat of munobj.features) {
			Datos.munis[feat.properties.iri] = { geometry: feat.geometry };
			Object.assign(Datos.munis[feat.properties.iri], feat.properties);
		}
		console.timeEnd("Proceso municipios simplificados al 10%");
  		
  		/*
  		// obtengo los municipios base de España del triplestore
		let munisbase = [];
		const datos = await Crafts.getData(config.craftsConfig.queryNopars, 
			{ queryName: "baseMunicipalities" }, true); // no la cacheo
		for (let row of datos.results.bindings) {
			// obtengo datos
			let mun = { iri: row.muni.value };
			// guardo cada resultado
			Datos.munis[mun.iri] = mun;
			munisbase.push(mun.iri);
		}
  		
		// inicializo las promesas
		let promesas = [];
  		// pido descomponer en objetos para la llamada resources de CRAFTS	
		const objrs = descomponerCraftsResources('BaseMunicipality', munisbase);			
		// ya tengo los objetos a pedir, lanzo las peticiones en paralelo a CRAFTS		
		for (let objr of objrs) {
			// creo una promesa para cada petición (todo paralelo)
			promesas.push( new Promise(async function(resolve, reject) {
				try {
					// hago la llamada a CRAFTS	y espero resultados (NO CACHEABLE)
					let datos = await Crafts.getData(config.craftsConfig.resourcesTemplate, objr, true);
					// convierto en array si es necesario
					if (!Array.isArray(datos))
						datos = [ datos ];			
					// actualizo municipio a municipio
					for (let dato of datos) {
						Object.assign(Datos.munis[dato.iri], dato);
						// reajuste geometría y bounding box
						if (Datos.munis[dato.iri].wkt) {
							Datos.munis[dato.iri].geometry = parse(Datos.munis[dato.iri].wkt); // transformo a GeoJSON
							delete Datos.munis[dato.iri].wkt;
							Object.assign(Datos.munis[dato.iri], getBoundingBox(Datos.munis[dato.iri].geometry));
						}
					}
					// resuelvo la promesa
					resolve(true);
				} catch(err) {
					reject(err);
				}
			}) );
		}
		
		// espero a que terminen todas las promesas
		await Promise.all(promesas);*/
	
		// guardo en la caché		
		Crafts.cacheandoAdhoc(munurl, Datos.munis);
    });	
}


////////
// PLOTS
////////

// función para coger parcelas aisladas => las manuales y bloqueadas en el arranque, así como las seleccionadas manualmente (para otros inventarios)
async function getPlotData(piris, ifn) {
	// obtengo las piris de las que no tengo datos
	const pendpiris = piris.filter((piri) => !Datos.parcelas[piri]);
	if (pendpiris.length > 0) {
		//inicializo las promesas
		const promesas = [];
		// hago llamadas con lotes de 60 iris
		const lote = 60;
		const niters = Math.ceil(pendpiris.length/lote);
		// inicializo variables de las consultas
		const pvar = "plot" + ifn;	
		const potrovar = config.ifnVersions[0] === ifn? "plot" + config.ifnVersions[1] : "plot" + config.ifnVersions[0];
		for (let i=0; i<niters; i++) {
			// creo promesa
			promesas.push( new Promise(async function(resolve, reject) {
				try {				
					// inicializo objeto de la petición a CRAFTS
					let objr = {
						piris: pendpiris.slice(lote*i, lote*(1 + i)),
						limit: 10000
					};
					objr[ifn] = true;
					// hago la llamada a CRAFTS	y espero resultados (cacheable)
					const datos = await Crafts.getData(config.craftsConfig.queryPlotvalues, objr, false);
					// extraigo los resultados
					for (let row of datos.results.bindings) {
						// continue only if not blank nodes
						if (row[pvar].type === "uri") {
							const puri = row[pvar].value;
							// inicializo parcela si no existe
							if (!Datos.parcelas[puri])
								Datos.parcelas[puri] = { 'iri': puri };
							if (!Datos.parcelas[puri].lat) {
								// cubre también el caso en que existe la parcela, pero falta esta info básica
								// (si se extrayeron los datos de los árboles desde otra parcela anterior o siguiente)
								Datos.parcelas[puri].lat = Number(row.lat.value),
								Datos.parcelas[puri].lng = Number(row.lng.value);
								Datos.parcelas[puri].ifn = ifn;
								Datos.parcelas[puri].prov = row.prov.value;
								if (row.muni)
									Datos.parcelas[puri].muni = row.muni.value;
								Datos.parcelas[puri].nt = {};
								Datos.parcelas[puri].ba = {};
								Datos.parcelas[puri].vwb = {};
								Datos.parcelas[puri].vwob = {};
								if (row[potrovar])
									Datos.parcelas[puri][potrovar] = row[potrovar].value;
								if (row.dataCapture)
									Datos.parcelas[puri].dataCapture = row.dataCapture.value;		
							}							
							// guardo la cuenta de especies de la fila (si existe)
							if (row.species) {
								const species = row.species.value;
								const nt = Number(row.nt.value);
								Datos.parcelas[puri].nt[species] = nt;
								const ba = Number(row.ba.value);
								Datos.parcelas[puri].ba[species] = ba;
								let vwb = Number(row.vwb.value);
								let vwob = Number(row.vwob.value);
								// apaño por el error en la conversión del IFN2
								if (vwb < vwob) {
									vwb = vwob;
									vwob = Number(row.vwb.value);
								}
								Datos.parcelas[puri].vwb[species] = vwb;
								Datos.parcelas[puri].vwob[species] = vwob;
							}
						}
					}
					// resuelvo la promesa
					resolve(true);
				} catch(err) {
					reject(err);
				}			
			}) );		
		}	
		
		// espero a que terminen las promesas pendientes
		await Promise.all(promesas);
	}
	// fue todo bien, resuelvo la promesa
	return Promise.resolve();
}


// función clave para obtener los candidatos para cachear datos de parcelas
function getCeldasParcelasCandidatas(arriba, ocgm, cz, ifn) {	
	// calculo rango de zooms permitidos
	const zini = config.zMin;
	// hacia abajo permito un máximo de 3 niveles para evitar explosión
	const zfin = cz + 3 > config.zMax? config.zMax : cz + 3;
	// obtengo candidatos sin incluir el zoom cz
	let objc = {};
	for (let z=zini; z<=zfin; z++) {
		// aquí es donde miro si es hacia arriba o hacia abajo
		if ( (arriba && z < cz) || (!arriba && z > cz) ) {
			if (ocgm[z]) { // sólo procedo si existe el nivel correspondiente de zoom
				objc[z] = []; // un array por nivel de zoom
				for (let x=ocgm[z].cellW; x<=ocgm[z].cellE; x++) {
					for (let y=ocgm[z].cellS; y<=ocgm[z].cellN; y++) {
						const et = 'z' + z + '_x' + x + '_y' + y + '_' + ifn;
						objc[z].push(et); // le enchufo la etiqueta
					}
				}
			}		
		}
	}
	return objc;
}
function getQueryCeldaParcelas(objcell) {
	// preparo objeto consulta celda
	const bounds = getCeldaBounds(objcell.cellX, objcell.cellY, objcell.zoom);
	let qobj = {
		"ifn2": objcell.ifn === "ifn2",
		"ifn3": objcell.ifn === "ifn3",
		"latsouth" : bounds.getSouth(),
		"latnorth" : bounds.getNorth(),
		"lngwest" : bounds.getWest(),
		"lngeast" : bounds.getEast(),
		"limit" : 10000
	};
	return qobj;
}

async function discoverPlotsInCell(objcell, sesion) {
	// preparo qobj por si tengo que hacer una petición a CRAFTS
	let qobj = getQueryCeldaParcelas(objcell);
	
	// preinicializo la celda si no existe
	if (!Datos.celdasParcelas[objcell.et])
		Datos.celdasParcelas[objcell.et] = { "pending": true };	
	
	// OBTENGO CANDIDATOS PARA EL CACHEO
	// obtengo matriz de grids para esta celda (pero sólo para los zooms usados)
	const ocgm = getCeldaGridMatrix(objcell.cellX, objcell.cellY, objcell.zoom, sesion.zoomUsados);
	// aquí tengo las celdas candidatas por nivel de zoom (generales y específicas, incluyendo la etiqueta de mycell)
	const candgen = getCeldasParcelasCandidatas(true, ocgm, objcell.zoom, objcell.ifn);
	const candesp = getCeldasParcelasCandidatas(false, ocgm, objcell.zoom, objcell.ifn);
	
	// compruebo si hay que obtener las parcelas de la celda
	if (Datos.celdasParcelas[objcell.et].pending) {
		// obtengo las parcelas de la celda		
		// inicializo puris como un objeto para guardar las parcelas recuperadas
		let puris = {};
		
		// si la celda no está en una zona válida (Iberia o Canarias) me ahorro las consultas
		let valida = false;
		const celdabounds = getCeldaBounds(objcell.cellX, objcell.cellY, objcell.zoom);
		for (let zona of config.zonasValidas) {
			const zonabounds = L.latLngBounds(zona);
			if (zonabounds.intersects( celdabounds ) )
				valida = true;
		}
		if (valida) {
			// intento cachear datos
			let bingo = false;
			// 1) posible inferencia: tengo los datos de la celda del nivel superior
			for (const z in candgen) {
				if (!bingo) {
					bingo = true; // inicializo para este bucle
					for (const et of candgen[z]) { // necesito todas las celdas de z
						if (!Datos.celdasParcelas[et] || Datos.celdasParcelas[et].pending) {
							bingo = false;
							break; // rompo bucle
						}
					}
					// guardo datos en caso de bingo
					if (bingo) {
						//console.info("Cacheo gen para celda " + objcell.et); //
						for (const et of candgen[z]) { // necesito todas las celdas de z
							for (let puri of Datos.celdasParcelas[et]) {
								// sólo incluyo las parcelas contenidas en la celda								
								const pev = Datos.parcelas[puri];
								if (celdabounds.getWest() <= pev.lng && celdabounds.getEast() >= pev.lng
										&& celdabounds.getNorth() >= pev.lat && celdabounds.getSouth() <= pev.lat)
									puris[puri] = true;
							}
						}
					}
				}
			}
			// 2) posible inferencia: tengo todos los datos de las celdas específicas
			if (!bingo) {
				for (const z in candesp) {
					if (!bingo) {			
						bingo = true; // inicializo para este bucle
						for (const et of candesp[z]) { // necesito todas las celdas de z
							if (!Datos.celdasParcelas[et] || Datos.celdasParcelas[et].pending) {
								bingo = false;
								break; // rompo bucle
							}
						}
						// guardo datos en caso de bingo
						if (bingo) {
							//console.info("Cacheo esp para celda " + objcell.et); //
							for (const et of candesp[z]) { // necesito todas las celdas de z
								for (let puri of Datos.celdasParcelas[et])
									puris[puri] = true;
							}
						}
					}
				}
			}
		
			// no hubo suerte, obtengo las parcelas de la celda para la primera página
			if (!bingo) {			
				//console.log(objcell.et + " - obteniendo lista de parcelas..."); // TODO			
				let indpag = 0;
				let maspags = false;
				// defino los nombres de variables según la versión del inventario
				const pvar = "plot" + objcell.ifn;
				const potrovar = config.ifnVersions[0] === objcell.ifn? "plot" + config.ifnVersions[1] : "plot" + config.ifnVersions[0];
				do {
					// ajuste offset
					qobj.offset = indpag * qobj.limit;
		
					// hago la llamada a CRAFTS	y espero resultados (cacheable)
					const datos = await Crafts.getData(config.craftsConfig.queryPlotsinbox, qobj,
						false, sesion.infoParcelas);
				
					// proceso los resultados (válido incluso con 0 resultados)
					for (let row of datos.results.bindings) {
						// continue only if not blank nodes
						if (row[pvar].type === "uri") {
							const puri = row[pvar].value;
							// inicializo parcela si no existe
							if (!Datos.parcelas[puri])
								Datos.parcelas[puri] = { 'iri': puri };
							if (!Datos.parcelas[puri].lat) {
								// cubre también el caso en que existe la parcela, pero falta esta info básica
								// (si se extrayeron los datos de los árboles desde otra parcela anterior o siguiente)
								Datos.parcelas[puri].lat = Number(row.lat.value),
								Datos.parcelas[puri].lng = Number(row.lng.value);
								Datos.parcelas[puri].ifn = objcell.ifn;
								Datos.parcelas[puri].prov = row.prov.value;
								if (row.muni)
									Datos.parcelas[puri].muni = row.muni.value;
								Datos.parcelas[puri].nt = {};
								Datos.parcelas[puri].ba = {};
								Datos.parcelas[puri].vwb = {};
								Datos.parcelas[puri].vwob = {};
								if (row[potrovar])
									Datos.parcelas[puri][potrovar] = row[potrovar].value;
								if (row.dataCapture)
									Datos.parcelas[puri].dataCapture = row.dataCapture.value;		
							}							
							// guardo la cuenta de especies de la fila (si existe)
							if (row.species) {
								const species = row.species.value;
								const nt = Number(row.nt.value);
								Datos.parcelas[puri].nt[species] = nt;
								const ba = Number(row.ba.value);
								Datos.parcelas[puri].ba[species] = ba;
								let vwb = Number(row.vwb.value);
								let vwob = Number(row.vwob.value);
								// apaño por el error en la conversión del IFN2
								if (vwb < vwob) {
									vwb = vwob;
									vwob = Number(row.vwb.value);
								}
								Datos.parcelas[puri].vwb[species] = vwb;
								Datos.parcelas[puri].vwob[species] = vwob;
							}
							// guardo la uri de la parcela
							puris[puri] = true; // si puri estuviera repetida se sobre-escribiría							
						}
					}
	
					// detecto si hay más páginas
					maspags = !(datos.results.bindings.length < qobj.limit);
					// incremento el índice
					indpag++;
				} while(maspags);
			}
		}
		
		// guardo puris en mi celda
		Datos.celdasParcelas[objcell.et] = Object.keys(puris); // aquí me quedo sólo con las claves		
	}
	
	//console.log(objcell.et + " - #parcelas: " + Datos.celdasParcelas[objcell.et].length);
	
	// actualizo estadísticos y progreso
	if (objcell.idtimeout == sesion.idTimeoutActualizar) {
		sesion.infoParcelas.celdasCompletadas.push(1);
		sesion.infoParcelas.parcelasCompletadas.push(Datos.celdasParcelas[objcell.et].length);
		if (sesion.progreso)
			sesion.progreso(true, sesion);
	}
	
	// me salgo si saltó el timeout
	if (objcell.idtimeout != sesion.idTimeoutActualizar) 
		return;

	// pinto las parcelas
	if (sesion.infoParcelas.pintar)
		pintarParcelas(Datos.celdasParcelas[objcell.et]); 

	// fue todo bien, resuelvo la promesa
	return Promise.resolve();
}

async function storePolygon(mipoliaux) {
	try {
		// guardo en la caché
		const polurl = config.craftsConfig.api + "/object?id=poli-" + mipoliaux.id;
		await Crafts.cacheandoAdhoc(polurl, mipoliaux.geojson);
	
		// guardo también en el triplestore
		const poliobj = {
			iri: config.descifnbase + "/poli/poli-" + mipoliaux.id,
			wkt: stringify(mipoliaux.geojson) // guardo como WKT
		};	
		const objpars = {
			iri: poliobj.iri,
			id: "Poli"
		};

		// hago la llamada a CRAFTS
		// creo el polígono con su geometría
		console.info("Guardando polígono " + mipoliaux.id + " en el triplestore...");
		await Crafts.putData(config.craftsConfig.resourceTemplate, objpars, poliobj);
		
		return true;
	} catch (error) {
		console.error(`Error storing polygon ${mipoliaux.id}:`, error);
		throw error;
	}
}

async function retrievePolygon(polid) {
	// intento recuperar de la caché
	const polurl = config.craftsConfig.api + "/object?id=poli-" + polid;
	try {
        const migeojson = await Crafts.getCacheData(polurl);
        console.log("Polígono "+polid+ " recuperado de la caché");
        return migeojson; // Return the cached data if available	
	} catch (cacheError) {
    	// no está, intento recuperar el polígono de la red
  		const objpars = {
			iri: config.descifnbase + "/poli/poli-" + polid,
			id: "Poli"
		};
		try {
			// hago la llamada a CRAFTS (NO LA CACHEO)
			const poli = await Crafts.getData(config.craftsConfig.resourceTemplate, objpars, true);
			// si hay wkt, extraigo el geojson
			if (poli.wkt) {
				console.log("Polígono "+polid+ " recuperado de la red");
				return parse(getLiteral(poli.wkt));
			}
			else
				throw new Error("WKT unavailable for polid: " + polid);
        } catch (networkError) {
        	// Log and propagate the network error
        	console.error("Error fetching polygon from the network:", networkError);
        	throw networkError;
        }
	}
}

async function deleteCachedPolygon(polid) {
	const polurl = config.craftsConfig.api + "/object?id=poli-" + polid;
	await Crafts.borradoCache(polurl);
}

async function downloadPolygonPlots(feat) {
	// obtengo grid que cubra el polígono para el zoom máximo
	const grid = getGrid(feat.bounds, config.zMin);
		
	// preparo un idtimeout
	const idtimeout = setTimeout( () => {}, 1000);
	// sólo me interesa el id, así que cancelo el timeout
	clearTimeout(idtimeout);
		
	// preparo objeto sesión para descargar los datos
	let sesion = {
		idTimeoutActualizar: idtimeout,
		zoomUsados: Sesion.zoomUsados,
		infoParcelas: {
			celdas: config.ifnVersions.length * (1 + grid.cellE - grid.cellW) * (1 + grid.cellN - grid.cellS), 
			celdasCompletadas: [],
			parcelasCompletadas: [],
			urlsRed: [],
			urlsCache: [],
			pintar: false
		}
	};
	sesion.progreso = function(mostrar, sesion) {
		const libarra = document.getElementById('li-barra');
		if (mostrar) {
			// pongo el overlay
			document.getElementById('mapoverlay').classList.remove('d-none');	
			// calculo celdas listas
			const clistas = sesion.infoParcelas.celdasCompletadas.reduce((memo, num) => memo + num, 0);
			const porc = Math.floor( 100 * clistas / sesion.infoParcelas.celdas );
			// pongo mensajillo
			document.getElementById('mapclue').innerHTML = feat.labprog;			
			// cojo refs barra
			const mibarradiv = document.getElementById('mibarradiv');
			const mibarra = document.getElementById('mibarra');
			// ajusto barra
			mibarradiv.setAttribute('aria-valuenow', porc);
			mibarra.style.width = porc + '%';
			mibarra.innerHTML = porc + '%';
			// muestro la barra de progreso
			libarra.classList.remove('d-none');	
		}
		else {
			// quito el overlay
			document.getElementById('mapoverlay').classList.add('d-none');			
			// escondo la barra
			libarra.classList.add('d-none');	
		}
	}
	
	// invoco progreso por primera vez
	sesion.progreso(true, sesion);
	
	// el objeto respuesta
	const objresp = {};
	
	// descargo las parcelas de cada versión del ifn
	for (let ifn of config.ifnVersions) {
		// descargo los datos
		let dpcpromises = [];
		// trabajo celda a celda
		for (let x=grid.cellW; x<=grid.cellE; x++) {
			for (let y=grid.cellS; y<=grid.cellN; y++) {
				// preparo objeto de la celda
				const objcelda = {
					zoom: config.zMin,
					cellX: x,
					cellY: y,
					et: 'z' + config.zMin + '_x' + x + '_y' + y + '_' + ifn,
					ifn: ifn,
					idtimeout: idtimeout
				};
				// hago la petición para descubrir las parcelas de la celda
				dpcpromises.push( discoverPlotsInCell(objcelda, sesion) );
			}
		}
		// espero a que terminen todas las promesas de las celdas
		await Promise.all(dpcpromises);	
		// obtengo iris de las parcelas del grid
		objresp[ifn] = [];
		for (let x=grid.cellW; x<=grid.cellE; x++) {
			for (let y=grid.cellS; y<=grid.cellN; y++) {
				const et = 'z' + config.zMin + '_x' + x + '_y' + y + '_' + ifn;
				objresp[ifn] = objresp[ifn].concat(Datos.celdasParcelas[et]);
			}
		}
		console.time("Filtrado " + ifn);
		// extraigo las parcelas correspondientes dependiendo del tipo de feature
		objresp[ifn] = objresp[ifn].filter((piri) => {
			//console.log(Datos.parcelas[piri]);
			//console.log(feat);		
			if (feat.type === 'municipality' && Datos.parcelas[piri].muni)
				return Datos.parcelas[piri].muni === feat.iri;
			else if (feat.type === 'province' && Datos.parcelas[piri].prov)
				return Datos.parcelas[piri].prov === feat.iri;
			else { // o es un polígono o la parcela no tiene la información de municipio o provincia				
				// resuelvo vía turf				
				return booleanPointInPolygon([Datos.parcelas[piri].lng, Datos.parcelas[piri].lat], feat.feature);
			}
		});
		console.timeEnd("Filtrado " + ifn);
	}
	
	// logging
	const urlsRed = sesion.infoParcelas.urlsRed.reduce((memo, num) => memo + num, 0);
	const urlsCache = sesion.infoParcelas.urlsCache.reduce((memo, num) => memo + num, 0);
	const plistas = sesion.infoParcelas.parcelasCompletadas.reduce((memo, num) => memo + num, 0);
	console.info("descarga I" + sesion.idTimeoutActualizar  + " #celdas: " + sesion.infoParcelas.celdas + 
			" #parcelas: " + plistas + 
			" #urlsRed: " + urlsRed + " #urlsCache: " + urlsCache);
	
	// fin descarga
	sesion.progreso(false, sesion);
	
	// incluyo info GA
	setEventData('num_cells', sesion.infoParcelas.celdas);
	setEventData('urls_network', urlsRed);
	setEventData('urls_cache', urlsCache);

	// devuelvo los datos
	return objresp;
}

async function downloadPlotInfo(plotreq) {
	// preparo objeto sesión para descargar los datos
	let sesion = {
		cancelar: false,
		infoParcelas: {
			parcelasTotales: 0,
			parcelasCompletadas: [],
			urlsRed: [],
			urlsCache: []
		}
	};
	// itero por cada edición del ifn para obtener parcelasTotales
	for (const ifn in plotreq) 
		sesion.infoParcelas.parcelasTotales += plotreq[ifn].length;
	// función para actualizar la barra de progreso
	sesion.progreso = function(mostrar, sesion) {
		if (sesion.cancelar)
			return; // para el caso en que haya cancelado
		const mibarradiv = document.getElementById('mibarradescarga_div');
		if (mostrar) {
			// calculo parcelas listas
			const plistas = sesion.infoParcelas.parcelasCompletadas.reduce((memo, num) => memo + num, 0);
			const porc = Math.floor( 100 * plistas / sesion.infoParcelas.parcelasTotales );
			// ajusto barra
			const mibarra = document.getElementById('mibarradescarga');
			mibarradiv.setAttribute('aria-valuenow', porc);
			mibarra.style.width = porc + '%';
			mibarra.innerHTML = porc + '%';
			// muestro la barra de progreso
			mibarradiv.classList.remove('d-none');	
		}
		else // escondo la barra
			mibarradiv.classList.add('d-none');
	}
	
	//console.log("#plots descarga: " + sesion.infoParcelas.parcelasTotales);
	
	// pongo un handler al botón de cancelar
	document.getElementById('downloadCancel').addEventListener('click', function(event) {
		// cambio flag para que no siga descargando
		sesion.cancelar = true;
		// actualizo info del evento y lo mando
		setEventData('content_type', 'download_canceled');
		const plistas = sesion.infoParcelas.parcelasCompletadas.reduce((memo, num) => memo + num, 0);
		const porc = Math.floor( 100 * plistas / sesion.infoParcelas.parcelasTotales );	
		const urlsRed = sesion.infoParcelas.urlsRed.reduce((memo, num) => memo + num, 0);
		const urlsCache = sesion.infoParcelas.urlsCache.reduce((memo, num) => memo + num, 0);
		setEventData('perc_progress', porc);
		setEventData('urls_network', urlsRed);
		setEventData('urls_cache', urlsCache);
		sendTimedEvent();
		// termino temporizador
		console.timeEnd("descarga info parcelas");
	});	
	
	// itero por cada edición del ifn para descargar los datos
	console.time("descarga info parcelas");
	for (const ifn in plotreq)  {
		if (plotreq[ifn].length == 0) {
			// nada que hacer, actualizo modal
			document.getElementById('noPlotsDownloaded'+ifn).classList.remove('d-none');		
			continue; // terminamos la iteración
		}	
		// caso normal: actualizo modal
		if (!sesion.cancelar) 
			document.getElementById('downloadingPlots'+ifn).classList.remove('d-none');
		
		// obtengo las piris de las que no tengo datos
		const piris = plotreq[ifn].filter((piri) => !Datos.parcelasDescarga[piri]);
		// actualizo parcelas con las parcelas de las que tengo datos
		const nptengo = plotreq[ifn].length - piris.length;
		if (nptengo > 0)
			sesion.infoParcelas.parcelasCompletadas.push(nptengo);
		// pinto progreso
		sesion.progreso(true, sesion);
		
		//console.log("#plots " + ifn + " en memoria: " + nptengo);
				
		// inspecciono la caché para ver si ya tuviera las parcelas cacheadas
		const [objcache, pendingpiris] = getCachedObjectMapping('Plot'+ifn, piris);
		
		const npcache = piris.length - pendingpiris.length;
		//console.log("#plots " + ifn + " en caché: " + npcache);
						
		// inicializo promesas
		let promesas = [];
		
		// recupero de la caché en paralelo
		for (const curl in objcache) {
			// creo una promesa para cada petición
			promesas.push( new Promise(async function(resolve, reject) {
				try {		
					// hago la llamada a la caché
					let datos = await Crafts.getCacheData(curl);
					// convierto en array si es necesario
					if (!Array.isArray(datos))
						datos = [ datos ];
					// actualizo parcela a parcela
					let npacts = 0;
					for (let dato of datos) {
						if (objcache[curl].includes(dato.iri)) { // sólo si estuviera en la caché
							Datos.parcelasDescarga[dato.iri] = dato;
							npacts++;
						}
					}
					// actualizo progreso
					sesion.infoParcelas.parcelasCompletadas.push(npacts);
					sesion.progreso(true, sesion);
					// resuelvo la promesa
					resolve(true);
				} catch(err) {
					reject(err);
				}
			}) );
		}
		
		// y voy haciendo en serie las peticiones a CRAFTS
		if (pendingpiris.length > 0) {
			// pido descomponer en objetos para la llamada resources de CRAFTS		
			const objrs = descomponerCraftsResources('Plot'+ifn, pendingpiris);			
			// ya tengo los objetos a pedir, lanzo las peticiones a CRAFTS con un paralelismo de MAX_HILOS
			const pagina = Math.ceil(objrs.length/MAX_HILOS);
			for (let i=0; i<MAX_HILOS; i++) {	
				// una promesa por cada hilo
				promesas.push( new Promise(async function(resolve, reject) {
					try {
						// voy página a página (y mientras no cancele el usuario)
						for (let j=0; j<pagina && (i + j*MAX_HILOS) < objrs.length && !sesion.cancelar; j++) {
							// recupero objr
							const objr = objrs[i + j*MAX_HILOS];
							// hago la llamada a CRAFTS	y espero resultados
							let datos = await Crafts.getData(config.craftsConfig.resourcesTemplate, objr, 
								false, sesion.infoParcelas);
							// convierto en array si es necesario
							if (!Array.isArray(datos))
								datos = [ datos ];					
							// actualizo parcela a parcela
							let npacts = 0;
							for (let dato of datos) {
								Datos.parcelasDescarga[dato.iri] = dato;
								npacts++;
							}
							// actualizo progreso
							sesion.infoParcelas.parcelasCompletadas.push(npacts);
							sesion.progreso(true, sesion);
						}					
						// resuelvo la promesa
						resolve(true);
					} catch(err) {
						reject(err);
					}
				}) );	
			}
		}
	
		// espero a que terminen las promesas de la caché (posiblemente ya hayan terminado)
		await Promise.all(promesas);
		
		// si no ha cancelado actualizo el modal
		if (!sesion.cancelar) {
			document.getElementById('downloadingPlots'+ifn).classList.add('d-none');
			document.getElementById('plotsDownloaded'+ifn).classList.remove('d-none');
		}
	}
	
	// logging
	const urlsRed = sesion.infoParcelas.urlsRed.reduce((memo, num) => memo + num, 0);
	const urlsCache = sesion.infoParcelas.urlsCache.reduce((memo, num) => memo + num, 0);
	const plistas = sesion.infoParcelas.parcelasCompletadas.reduce((memo, num) => memo + num, 0);
	console.info("descarga info parcelas - #totales: " + sesion.infoParcelas.parcelasTotales 
		+  " #descargadas: " + plistas + " #urlsRed: " + urlsRed + " #urlsCache: " + urlsCache);	

	// actualizo info del evento
	setEventData('urls_network', urlsRed);
	setEventData('urls_cache', urlsCache);
		
	// fin descarga
	sesion.progreso(false, sesion);	
	
	// pongo mensajillo de preparando ficheros y termino temporizador
	if (!sesion.cancelar) {
		document.getElementById('preparingFiles').classList.remove('d-none');
		console.timeEnd("descarga info parcelas");
	}
	
	// devuelvo booleano de cancelado
	return sesion.cancelar;
}

export { getTaxonsInfo, getProvincesInfo, getMunicipalitiesInfo, getPlotData, discoverPlotsInCell,
	 storePolygon, retrievePolygon, deleteCachedPolygon, downloadPolygonPlots, downloadPlotInfo };